module.exports = __webpack_public_path__ + "img/Wp_2055.2ff17351.png";